import { render } from "./Themer.vue?vue&type=template&id=ca85c838&scoped=true"
import script from "./Themer.vue?vue&type=script&lang=js"
export * from "./Themer.vue?vue&type=script&lang=js"

import "./Themer.vue?vue&type=style&index=0&id=ca85c838&lang=css"
import "./Themer.vue?vue&type=style&index=1&id=ca85c838&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ca85c838"

export default script